import { Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Redirects bare paths (e.g. /pricing) to their localized version (e.g. /es/pricing).
 * Reads the user's current language preference from i18n.
 */
export default function LanguageRedirect() {
  const { i18n } = useTranslation();
  const location = useLocation();
  
  const lang = i18n.language === 'en' ? 'en' : 'es';
  const targetPath = `/${lang}${location.pathname}${location.search}${location.hash}`;
  
  return <Navigate to={targetPath} replace />;
}
